import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiPost } from "../../api/apiclient";
import { CREATE_AI_AGENT } from "../../api/endpoints";
import {  INITIAL_VALUES_STATE } from "../../utills/constant";

// Async thunk for creating AI agents
export const createAIAgents = createAsyncThunk(
  "ai_agent",
  async (params, { rejectWithValue }) => {
    console.log('params',params)
    try {
       const response = await apiPost(CREATE_AI_AGENT,params);
      if (response?.data.status === "success") {
        return response.data;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);



const NewAgenSelectorSlice = createSlice({
  name: "ai_agent",
  initialState: {
    createAgentLoading: false,
    createAgentError: null,
    createAgent: null,
    outputOcrFields:[],
    slugName:null,
    bucketName:{},
    formDetails: {
      
     ...INITIAL_VALUES_STATE
      

    },
  },
  reducers: {
    saveFormDetails: (state, action) => {
      const { key, value } = action.payload;
      state.formDetails[key] = value !== undefined ? value : INITIAL_VALUES_STATE[key];
    },

    saveOutPutOcrFinalFields: (state, action) => {
      state.outputOcrFields =  action.payload
    },
    
    saveSlugName: (state, action) => { 
      state.slugName = action.payload; // Dynamically update form details
    },
    resetCreateAgent:(state,payload)=>{
      state.createAgentLoading= false
      state.createAgentError= null
      state.createAgent= null
    },
    resetFormDetails:(state,payload)=>{
      state.formDetails={ ...INITIAL_VALUES_STATE}
    },
  
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAIAgents.pending, (state) => {
        state.createAgentLoading = true;
        state.createAgentError = null;
      })
      .addCase(createAIAgents.fulfilled, (state, action) => {
        state.createAgentLoading = false;
        state.createAgent =  action.payload
        state.bucketName =  action?.payload
      })
      .addCase(createAIAgents.rejected, (state, action) => {
        state.createAgentLoading = false;
        state.createAgentError = action.payload;
      });
  },
});

// Exporting the action to save form details
export const { saveFormDetails,resetCreateAgent,saveSlugName ,resetFormDetails,saveOutPutOcrFinalFields} = NewAgenSelectorSlice.actions;

// Exporting the reducer
export default NewAgenSelectorSlice.reducer;
